import { useContext, useState } from "react";
import { AppContext } from "../App";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";
import banner6 from "../assets/banner6.jpg";
import { MdArrowForward } from "react-icons/md";

const services = [
  { 
    id: "01", 
    title: "Property Leasing", 
    desc: "Lease residential properties and transform them into professionally managed short-term accommodation.",
    img: banner1,
    size: "large",
    accent: "#BC9132"
  },
  { 
    id: "02", 
    title: "Property Management", 
    desc: "Co-hosting, listing optimization, guest communication, housekeeping, and maintenance coordination.",
    img: banner2,
    size: "small",
    accent: "#012243"
  },
  { 
    id: "03", 
    title: "Corporate Accommodation", 
    desc: "Serviced apartments and furnished stays for corporate organizations, consultants, expatriates and business travellers.",
    img: banner3,
    size: "small",
    accent: "#BC9132"
  },
  { 
    id: "04", 
    title: "Travel Consultation", 
    desc: "Airport transfers, local guidance, transport coordination, and concierge support.",
    img: banner4,
    size: "small",
    accent: "#012243"
  },
  { 
    id: "05", 
    title: "Local Experiences", 
    desc: "Curated tours, cultural experiences, city excursions, and adventure activities.",
    img: banner5,
    size: "small",
    accent: "#BC9132"
  },
  { 
    id: "06", 
    title: "Long-Term Value", 
    desc: "A trusted hospitality brand focused on quality, professionalism, and sustainable growth.",
    img: banner6,
    size: "large",
    accent: "#012243"
  }
];

export default function ServicesBanner1() {
  const appContext = useContext(AppContext);
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300&display=swap');
        
        :root {
          --sunflower-amber: #BC9132;
          --text-navy: #012243;
          --text-slate: #475569;
          --bg-light: #F8FAFC;
          --bg-white: #FFFFFF;
          --border-clean: rgba(1, 34, 67, 0.06);
          --font-modern: 'Plus Jakarta Sans', sans-serif;
        }

        .services-modern {
          padding: 100px 0;
          background: var(--bg-light);
          font-family: var(--font-modern);
          color: var(--text-navy);
        }

        .services-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 32px;
        }

        /* Redesigned Clean Header */
        .services-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          gap: 40px;
          margin-bottom: 60px;
        }

        .services-title-wrap {
          max-width: 600px;
        }

        .services-eyebrow {
          font-size: 0.8rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          color: var(--sunflower-amber);
          margin-bottom: 12px;
          display: block;
        }

        .services-title {
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 800;
          line-height: 1.15;
          letter-spacing: -0.03em;
          margin: 0;
        }

        .services-title .italic {
          font-style: italic;
          font-weight: 300;
          color: var(--sunflower-amber);
        }

        .services-subtitle {
          font-size: 1rem;
          color: var(--text-slate);
          line-height: 1.6;
          max-width: 380px;
          margin: 0;
        }

        /* Modernized Asymmetrical Bento Grid Layout */
        .bento-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        /* Enhanced Card Design */
        .bento-card {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          background: var(--bg-white);
          border: 1px solid var(--border-clean);
          min-height: 340px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 32px;
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.01);
          transition: transform 0.5s cubic-bezier(0.215, 0.610, 0.355, 1), 
                      box-shadow 0.5s cubic-bezier(0.215, 0.610, 0.355, 1);
        }

        /* Custom item scaling to look dynamic */
        .bento-card.size-large {
          grid-column: span 2;
        }

        .bento-card.size-small {
          grid-column: span 1;
        }

        /* Background Image Logic */
        .card-img-wrap {
          position: absolute;
          inset: 0;
          z-index: 1;
          overflow: hidden;
        }

        .card-img-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.7s ease;
        }

        /* Unified overlay transition */
        .card-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, 
            rgba(1, 34, 67, 0.1) 0%, 
            rgba(1, 34, 67, 0.5) 45%, 
            rgba(1, 34, 67, 0.95) 100%);
          z-index: 2;
          transition: opacity 0.5s ease;
        }

        /* Card Content layout */
        .card-content {
          position: relative;
          z-index: 3;
          color: #ffffff;
        }

        .card-header-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: auto;
          position: absolute;
          top: -180px;
          left: 0;
          right: 0;
        }

        .card-id {
          font-size: 0.75rem;
          font-weight: 700;
          opacity: 0.6;
          letter-spacing: 0.1em;
        }

        .card-arrow-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.4s ease;
          color: #ffffff;
        }

        /* Card Text styling */
        .card-title {
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 0 10px 0;
          letter-spacing: -0.01em;
          transition: color 0.3s ease;
        }

        .card-desc {
          font-size: 0.92rem;
          line-height: 1.5;
          margin: 0;
          color: rgba(255, 255, 255, 0.75);
        }

        /* Interactive Micro-animations on Hover */
        .bento-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(1, 34, 67, 0.12);
        }

        .bento-card:hover .card-img-wrap img {
          transform: scale(1.05);
        }

        .bento-card:hover .card-arrow-icon {
          background: #ffffff;
          color: var(--text-navy);
          transform: translate(2px, -2px);
        }

        /* Clean Redesigned Bottom CTA Section */
        .services-bottom {
          margin-top: 60px;
          padding-top: 40px;
          border-top: 1px solid var(--border-clean);
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 32px;
        }

        .services-bottom-text {
          font-size: 1.05rem;
          color: var(--text-slate);
          margin: 0;
          max-width: 540px;
          line-height: 1.6;
        }

        .services-bottom-text strong {
          color: var(--text-navy);
          font-weight: 700;
        }

        .services-bottom-cta {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: 16px 32px;
          background: var(--text-navy);
          color: #ffffff;
          text-decoration: none;
          border-radius: 12px;
          font-size: 0.9rem;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .services-bottom-cta:hover {
          background: var(--sunflower-amber);
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(188, 145, 50, 0.2);
        }

        /* Responsive Breakpoints Rules */
        @media (max-width: 1024px) {
          .bento-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .bento-card.size-large,
          .bento-card.size-small {
            grid-column: span 1;
          }
        }

        @media (max-width: 768px) {
          .services-modern { padding: 60px 0; }
          .services-container { padding: 0 24px; }
          .services-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            margin-bottom: 40px;
          }
          .bento-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .bento-card {
            min-height: 280px;
            padding: 24px;
          }
          .services-bottom {
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
            margin-top: 40px;
          }
        }
      `}</style>

      <section className="services-modern" id="services">
        <div className="services-container">
          
          {/* Section Header */}
          <div className="services-header">
            <div className="services-title-wrap">
              <span className="services-eyebrow">Capabilities</span>
              <h2 className="services-title">
                Mirabel <span className="italic">services</span> overview.
              </h2>
            </div>
            <p className="services-subtitle">
              Tailored premium property management and localized luxury hospitality ecosystems.
            </p>
          </div>

          {/* Bento Grid */}
          <div className="bento-grid">
            {services.map((service) => (
              <div 
                key={service.id}
                className={`bento-card size-${service.size}`}
                style={{ '--accent-color': service.accent }}
                onMouseEnter={() => setHoveredId(service.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div className="card-img-wrap">
                  <img src={service.img} alt={service.title} />
                </div>
                <div className="card-overlay" />
                
                <div className="card-content">
                  <div className="card-header-top">
                    <span className="card-id">{service.id}</span>
                  </div>
                  
                  <h3 className="card-title">{service.title}</h3>
                  <p className="card-desc">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="services-bottom">
            <p className="services-bottom-text">
              Ready to stay, partner, or build alongside <strong>Mirabel Suites</strong>? Let's unlock value together.
            </p>
            <a 
              href="#contact" 
              className="services-bottom-cta"
              onClick={(e) => {
                e.preventDefault();
                appContext?.navTo?.({ item: "contact_us" });
              }}
            >
              <span>Start Partnership</span>
              <MdArrowForward size={16} />
            </a>
          </div>
          
        </div>
      </section>
    </>
  );
}